/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Email_ToInputs */

const en_mobile_email_to = /** @type {(inputs: Mobile_Email_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email to`)
};

const es_mobile_email_to = /** @type {(inputs: Mobile_Email_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar a`)
};

/**
* | output |
* | --- |
* | "Email to" |
*
* @param {Mobile_Email_ToInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_email_to = /** @type {((inputs?: Mobile_Email_ToInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Email_ToInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_email_to(inputs)
	return en_mobile_email_to(inputs)
});